<template>
  <v-container class="pa-10">
    <v-row>
      <v-col>{{ $t("storyHub.publishing.yourStoryIsStillADraft") }}</v-col>
    </v-row>
    <v-row>
      <h1>{{ $t("storyHub.publishing.publishWizard") }}</h1>
    </v-row>
    <v-row>
      <v-card
        class="justify-center rounded-xl"
        color="secondaryBackground"
        style="width: 100%; min-height: 35vh"
      >
        <v-container fill-height fluid>
          <v-row align="center" justify="center">
            <v-col>
              <v-btn
                @click="toggleDialog(true)"
                class="px-14 white--text"
                x-large
                color="primaryAction"
                ><v-icon large left>mdi-rocket</v-icon>
                {{ $t("storyHub.publishing.startPublishing") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
    <v-row class="mt-10">
      <v-spacer />
      <v-col cols="2">
        <v-btn color="secondaryAction" class="white--text"
          ><v-icon left>mdi-delete</v-icon
          >{{ $t("storyHub.publishing.deleteStory") }}</v-btn
        >
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition">
      <Wizard @close="dialog = false" :published="false" />
    </v-dialog>
  </v-container>
</template>
<script>
import hasWizardDialog from "@/mixins/hasWizardDialog"
import Wizard from "./Wizard"
export default {
  components: {
    Wizard,
  },
  mixins: [hasWizardDialog],
}
</script>